<h3>Are you sure?</h3>
<div class="card-body ">
    <h4>There are unsaved changes, please save or stay to keep on editing!
    </h4>
</div>
<div class="row align-items-right">
    <div class="col-4">
        <button class="btn btn-link btn-block" (click)="save()">
            Save
        </button>
    </div>
    <div class="col-4">
        <button class="btn btn-primary btn-block" (click)="stay()">
            Stay
        </button>
    </div>
</div>